import React                         from 'react';
import { Observe }                        from 'rewire-core';
import { createColumn }                   from 'rewire-grid';
import IconButton                         from '@material-ui/core/IconButton';
import RefreshIcon                        from '@material-ui/icons/Refresh';
import { makeStyles }                     from '@material-ui/core/styles';
import { StyleType }                      from '../utility/styles';
import MainContentToolbar                 from '../main-navigation/MainContentToolbar';
import Breadcrumbs                        from '../main-navigation/Breadcrumbs';
import { createGridSettings, hasChanges } from './DefaultSettingsView';
import GridLayout                         from './GridLayout';
import Loader                             from '../ui/Loader';
import PrioritySortMenu                   from '../ui/PrioritySortMenu';
import SettingsModel                      from './SettingsModel';
import { useCardStyle }                   from './UdfEditor';
import Button                             from '@material-ui/core/Button';
import Icon                               from '@material-ui/core/Icon';

const SortMenu = ({settings}: {settings: SettingsModel}) => {
  return settings.sortModel ? <PrioritySortMenu menuId='settings-sort' classes={{}} model={settings.sortModel} /> : null;
};

const [permissionsGridModel, pOldSelectCells] = createGridSettings([
  // createColumn('checked', '',  {type: 'none', renderer: CheckedIconRenderer, editable: true, width: '5%' }),
  createColumn('name', 'Name', {type: 'text', width: '100px', align: 'left', readOnly: true}),
]);

const useItemsPanelViewStyles = makeStyles(_theme => ({
  left: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    overflow: 'auto',
    justifyContent: 'flex-start',
  },
  right: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  addButton: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '10px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
}));

const RolePermissionSettingsItemsPanelView = ({settings, refresh, classes}: {settings: SettingsModel, refresh: () => void, classes?: StyleType<typeof useCardStyle>}) => {
  const itemsClasses = useItemsPanelViewStyles();

  return (
    <>
      <MainContentToolbar>
        <div className={itemsClasses.left}>
          <Breadcrumbs />
        </div>
        <div className={itemsClasses.right}>
          <Observe render={() =>
              <Button className={itemsClasses.addButton} variant='contained' onClick={settings.addItem} disabled={hasChanges() || !settings.canAddItem()}>
                <Icon className='add'>{'add'}</Icon>
                {`Add ${settings.title}`}
              </Button>
            } />
          <IconButton onClick={refresh} aria-label='Refresh'>
            <RefreshIcon />
          </IconButton>
          <SortMenu settings={settings} />
          {/* <PermissionGridBottomMenu settings={(settings as RolesSettingsModel)} /> */}
        </div>
      </MainContentToolbar>

      <Observe render={() => (
         <Loader loading={settings.isLoading}>
           <Observe render={() => (
             <GridLayout settings={settings} classes={classes} grid={permissionsGridModel} oldSelect={pOldSelectCells} />
           )} />
        </Loader>
      )} />
    </>
  );
};

export default RolePermissionSettingsItemsPanelView;
